export const backendApiPrefix = 'https://srijan-ecommerce-store-backend.vercel.app/api'
